/* src/app/components/star-container/star-container.component.scss */
div[app-star] {
  height: 16px;
}
/*# sourceMappingURL=star-container.component.css.map */
